import { motion } from "framer-motion";

const STEPS = [
  {
    n: "01",
    title: "Send the signal",
    body: "Tap request, pick your service and drop your location. Takes under 30 seconds — no login, no paperwork.",
  },
  {
    n: "02",
    title: "We dispatch instantly",
    body: "Our control room routes the nearest verified technician and shares a live ETA to your phone.",
  },
  {
    n: "03",
    title: "Help arrives",
    body: "Trained rescue crew reaches you with the right kit, fixes the problem on the spot or tows you safely.",
  },
  {
    n: "04",
    title: "Back on the road",
    body: "Transparent pricing, digital receipt and optional insurance issued right there. You just drive on.",
  },
];

export const Manifesto = () => {
  return (
    <section id="how" className="relative bg-rescue-surface py-24 sm:py-32 border-y border-white/10">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="mb-16 max-w-2xl">
          <span className="text-rescue-primary font-semibold uppercase tracking-[0.3em] text-xs">
            The protocol
          </span>
          <h2 className="font-display uppercase tracking-tighter text-white text-6xl sm:text-7xl lg:text-8xl leading-[0.85] mt-4">
            Four steps.<br />Zero panic.
          </h2>
        </div>

        <div className="divide-y divide-white/10 border-t border-white/10">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              data-testid={`manifesto-step-${s.n}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
              className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-8 md:py-10 items-baseline"
            >
              <span className="md:col-span-3 font-display text-7xl sm:text-8xl leading-none text-white/15 group-hover:text-rescue-primary transition-colors duration-500">
                {s.n}
              </span>
              <h3 className="md:col-span-4 font-display uppercase tracking-tight text-white text-3xl sm:text-4xl leading-none">
                {s.title}
              </h3>
              <p className="md:col-span-5 text-white/60 text-base leading-relaxed">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
